import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode } from 'react';

type BaseProps = {
  children: ReactNode;
  className?: string;
  rounded?: 'xl' | '2xl' | '3xl' | 'full';
};

const roundedClass = {
  xl: 'rounded-xl',
  '2xl': 'rounded-2xl',
  '3xl': 'rounded-3xl',
  full: 'rounded-full',
};

type DivGlassProps = BaseProps & { as?: 'div' } & HTMLAttributes<HTMLDivElement>;
type ButtonGlassProps = BaseProps & { as: 'button' } & ButtonHTMLAttributes<HTMLButtonElement>;

export type GlassSurfaceProps = DivGlassProps | ButtonGlassProps;

export function GlassSurface(props: GlassSurfaceProps) {
  const { children, className = '', rounded = '2xl', as = 'div', ...rest } = props;
  const base = `glass-surface refractive-border ${roundedClass[rounded]} ${as === 'button' ? 'lg:cursor-pointer' : ''} ${className}`;

  if (as === 'button') {
    const { type = 'button', ...buttonRest } = rest as ButtonHTMLAttributes<HTMLButtonElement>;
    return (
      <button type={type} className={base} {...buttonRest}>
        {children}
      </button>
    );
  }

  return (
    <div className={base} {...(rest as HTMLAttributes<HTMLDivElement>)}>
      {children}
    </div>
  );
}
